import React, { useEffect, useRef, useState } from "react";

import { useAppContext } from "../../config/AppContext";

import { useSnackbar } from "notistack";
import { doc } from "firebase/firestore";
import { Spin } from "antd";

import PrimaryButton from "../../buttons/PrimaryButton";

import Space from "../../layout/Space";
import {
  Attestation,
  MaitreOeuvre,
  Org,
  RTB_RE20,
  User,
  Xml,
} from "../../types/basicTypes";
import { transformFilesToTable } from "../../models/OrgFunctions";
import Icon1 from "../../assets/icons/Icon";
import TabGPT from "../../tabs/TabGPT";
import DataGridGPT2 from "../../tables/DataGridGPT2";
import SearchBarFolders from "../../textfields/SearchBarFolders";
import BasicSearchBar from "../../textfields/BasicSearchBar";
import {
  getDocDataById,
  getFlutterTime,
  getLocalDateFromFlutter,
  getLocalFromFlutterString,
  getRefFromId,
  queryCollection,
} from "../../models/DataFunctions";
import createDocApi from "../../api/database/createDocApi";
import SmallSpinner from "../../loading/SmallSpinner";
import { generateID, InfosBlockModify } from "./helpers/generalHelpers";
import NewAttestationModal from "./init/NewAttestationModal";
import ModalRight from "../../modals/ModalRight";
import SecondaryButton from "../../buttons/SecondaryButton";
import deleteDocApi from "../../api/database/deleteDocApi";
import updateDocApi from "../../api/database/updateDocApi";
import { useParams, useSearchParams } from "react-router-dom";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import refreshFileUrl from "../../api/upload/refreshFileUrl";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import extractXml from "../../api/xml/extractXml";
import generatePDF from "../../api/xml/generatePDF";
import generateBoth from "../../api/xml/generateBoth";
import xmlPresignUrl from "../../api/presign/xmlPresignUrl";
import sendRTBatiment from "../../api/send/sendRTBatiment";
import SexySpin from "../../assets/SexySpinner";
import generateATH2 from "../../api/xml/generateATH2";
import convertWord from "../../api/upload/convertWord";

interface FoldersProps {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  setCanFetchFolders: (canFetch: boolean) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
}

function Folders({
  userData,
  orgData,
  navigateWorkspace,
  setCanFetchFolders,
  handleClickVariant,
}: FoldersProps) {
  const [tag_open, setTagOpen] = useState(false);
  const { appState, setAppState, fetchCarnets, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const folders_config = appState.folders_config;
  const saved_data = appState.saved_data;

  const [searchParams] = useSearchParams();
  const use_xml_id = searchParams?.get("use_xml_id");
  const [usedXml, setUsedXml] = useState<Xml | undefined>(undefined);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [options, setOptions] = useState<any>([]);
  const [year, setYear] = useState(null);
  const [loadingRows, setLoadingRows] = useState(true);
  const [new_open, setNewOpen] = useState(false);
  const [modifyAttestation, setModifyAttestation] = useState(false);
  const [selected_ids, setSeletedIds] = useState<string[]>([]);
  const [updatedAttestation, setUpdatedAttestation] = useState<
    Attestation | undefined
  >(undefined);
  const [newAttestation, setNewAttestation] = useState<Attestation | undefined>(
    undefined
  );
  const handleSetSeachValue = (value: string) => {
    setSearchValue(value);
  };
  const [loadingData, setLoadingData] = useState(false);

  const years = [
    { value: 2024, label: "2024" },
    { value: 2025, label: "2025" },
  ];

  const [tag_folder_id, setTagFolderId] = useState(null);
  const [tag_index, setTagIndex] = useState(1);
  const [loadingFile, setLoadingFile] = useState<string>("");
  // Function to navigate to a client by ID
  const gotoFolder = async (id: any) => {
    setLoadingFile(id.id);
    let updatedAttestation = (await getDocDataById(
      "attestation",
      id.id
    )) as Attestation;
    if (updatedAttestation) {
      const token = await getOrRefreshFirebaseToken();
      let new_url = await refreshFileUrl(
        updatedAttestation.file?.id,
        token,
        prefix
      );
      await updateDocApi(
        "attestation",
        updatedAttestation.id,
        {
          ...updatedAttestation,
          file: {
            ...updatedAttestation.file,
            url: new_url,
          },
        },
        prefix
      );

      updatedAttestation = (await getDocDataById(
        "attestation",
        id.id
      )) as Attestation;
    }

    setUpdatedAttestation(updatedAttestation);
    setModifyAttestation(true);
    setLoadingFile("");
  };

  // Function to navigate to a client by name
  const gotoFolderName = (option: any) => {
    handleSearchChange(option.label);
    // Find the client with the matching name
  };

  const [update_search, setUpdateSearch] = useState(false);
  const handleSearchChange = async (name: string) => {
    handleSetSeachValue(name);
    setUpdateSearch(true);
  };

  const [tabs = [], setTabs] = useState<any>([]);

  const [allattestations, setAllAttestations] = useState<Attestation[]>([]);
  const tabContent = [<span></span>, <span></span>, <span></span>];
  const [particulier_folders, setParticulierFolders] = useState([]);

  const [masters, setMasters] = useState([]);
  const [only_folder_filter, setOnlyFolderFilter] = useState(
    folders_config?.only_folder_filter || null
  );
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [activetab, setactivetab] = useState("all");
  const [clients, setClients] = useState([]);
  const [partners, setPartners] = useState<MaitreOeuvre[]>([]);

  const [searchCarnets, setsearchCarnets] = useState(
    folders_config?.search_folders || "folders"
  );
  const [tagFilterOpen, setTagFilterOpen] = useState(false);
  const [tag_filters, setTagFilters] = useState([]);

  const [carbonBatch, setCarbonBatch] = useState<any[]>([]);
  const [extractStep, setExtractStep] = useState<
    "carbon" | "insulator_carbon" | null
  >(null);

  const [users, setUsers] = useState([]);

  const handleTabChange = async (newTab: any) => {
    let new_folders_config = folders_config || {};
    new_folders_config.tab = newTab;
    // set folders_config
    setAppState((prevState: any) => ({
      ...prevState,
      folders_config: new_folders_config,
    }));

    setactivetab(newTab);
  };

  const handleSaveAttestation = async () => {
    if (!updatedAttestation) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }
    updatedAttestation.last_updated = getFlutterTime();
    await updateDocApi(
      "attestation",
      updatedAttestation.id,
      updatedAttestation,
      prefix
    );
    handleClickVariant("Attestation mise à jour avec succès", "success");
    setUpdatedAttestation(updatedAttestation);
    setModifyAttestation(false);
    handleFetchData();
  };

  const handleDeleteSelectedAttestations = async () => {
    if (selected_ids.length === 0) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }
    setLoadingDelete(true);
    let refs = selected_ids.map((id) => getRefFromId("attestation", id));
    if (refs.length > 0) {
      try {
        await Promise.all(
          refs
            .filter((ref) => ref !== null && ref !== undefined) // Filter out any null references
            .map((ref) => deleteDocApi(ref!, prefix))
        );
        handleClickVariant("Attestations supprimées avec succès", "success");
        setUpdatedAttestation(undefined);
        setSeletedIds([]);
        handleFetchData();
      } catch (error) {
        console.error("Error deleting attestations:", error);
        handleClickVariant(
          "Erreur lors de la suppression des attestations",
          "error"
        );
      }
    } else {
      handleClickVariant("Aucune attestation trouvée", "error");
    }
    setLoadingDelete(false);
  };

  const handleDownloadWord = async () => {
    if (!updatedAttestation) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }

    if (!updatedAttestation.file || !updatedAttestation.file.url) {
      handleClickVariant("Aucun fichier associé à cette attestation", "error");
      return;
    }

    setLoadingFile("word-download");
    const token = await getOrRefreshFirebaseToken();

    let new_file = await convertWord(updatedAttestation.file, token, prefix);
    setLoadingFile("");
    if (!new_file.url) {
      handleClickVariant("Erreur lors de la conversion du fichier", "error");

      return;
    }

    const response = await fetch(new_file.url);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = new_file.name || "attestation.docx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    handleClickVariant("Fichier Word téléchargé avec succès", "success");
  };

  const handleDownload = async () => {
    if (!updatedAttestation) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }

    if (!updatedAttestation.file || !updatedAttestation.file.url) {
      handleClickVariant("Aucun fichier associé à cette attestation", "error");
      return;
    }

    try {
      const response = await fetch(updatedAttestation.file.url);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = updatedAttestation.file.name || "attestation.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
      handleClickVariant("Erreur lors du téléchargement du fichier", "error");
    }
  };

  const handleDeleteAttestation = async () => {
    if (loadingDelete) {
      handleClickVariant("Suppression en cours, veuillez patienter...", "info");
      return;
    }
    if (!updatedAttestation) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }

    let ref = getRefFromId("attestation", updatedAttestation?.id);
    if (ref) {
      await deleteDocApi(ref!, prefix);
      handleClickVariant("Attestation supprimée avec succès", "success");
      setUpdatedAttestation(undefined);
      handleFetchData();
    } else {
      handleClickVariant(
        "Erreur lors de la suppression de l'attestation",
        "error"
      );
    }
    setModifyAttestation(false);
  };

  const creatingFromXml = useRef(false);

  const handleCheckUseXmlId = async () => {
    console.log("handleCheckUseXmlId", use_xml_id);
    if (use_xml_id && !creatingFromXml.current) {
      creatingFromXml.current = true;
      try {
        let xml = await getDocDataById("xml", use_xml_id);
        if (xml) {
          handleCreateNewAttestation(xml);
          setUsedXml(xml);
        }
      } catch (error) {
        console.error("Error fetching XML data:", error);
        handleClickVariant("Erreur lors de la récupération de l'XML", "error");
      }
    }
  };
  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (orgData) {
      // Fetch user data by currentUser's ID

      let filters = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];
      let attestations = (await queryCollection(
        "attestation",
        filters
      )) as Attestation[];
      let partners = (await queryCollection(
        "partner",
        filters
      )) as MaitreOeuvre[];
      setPartners(partners);
      // let carnets = await fetchCarnets(orgData);
      setAllAttestations(attestations);
      setOptions(
        attestations.map((folder: Attestation) => ({
          label: folder.name,
          value: folder.id,
        }))
      );

      setTabs([
        {
          label: "Tous",
          id: "all",
        },

        {
          label: "Isolants & carbone",
          id: "insulator",
        },
        {
          label: "RT Batiment",
          id: "rtb",
        },
      ]);

      setTimeout(() => {
        setLoadingRows(false);
      }, 100);
      // Set options for the search bar (client names)
      let end_time = new Date().getTime();
    }
  };

  const generateRTBAttestation = async (
    xml: Xml | undefined,
    rtb: RTB_RE20 | null
  ) => {
    if (
      orgData.facturation.plan !== "active" &&
      orgData.counters?.attestations >= 5
    ) {
      handleClickVariant(
        "Vous avez atteint la limite de 5 attestations. Veuillez mettre à niveau votre plan pour en créer plus.",
        "error"
      );
      return;
    }
    setLoadingData(true);
    let xml_url = await xmlPresignUrl(
      use_xml_id ? use_xml_id : xml?.id,
      prefix
    );
    if (!xml_url) {
      handleClickVariant(
        "Erreur lors de la récupération du fichier XML",
        "error"
      );
      setLoadingData(false);
      return;
    }
    const { url, attestationId } = await sendRTBatiment(
      use_xml_id ? use_xml_id : xml?.id,
      rtb,
      prefix
    );
    if (!url || !attestationId) {
      handleClickVariant(
        "Erreur lors de la génération de l'attestation",
        "error"
      );
      setLoadingData(false);
      return;
    }
    let attestation: Attestation = (await getDocDataById(
      "attestation",
      attestationId
    )) as Attestation;
    setNewAttestation(attestation);
    setLoadingData(false);
    handleClickVariant(
      "Attestation RT Batiment générée avec succès",
      "success"
    );
  };

  const generateInsulatorAttestation = async (xml: Xml | undefined) => {
    if (
      orgData.facturation.plan !== "active" &&
      orgData.counters?.attestations >= 5
    ) {
      handleClickVariant(
        "Vous avez atteint la limite de 5 attestations. Veuillez mettre à niveau votre plan pour en créer plus.",
        "error"
      );
      return;
    }

    console.log("generateInsulatorAttestation", xml);
    setLoadingData(true);
    let xml_url = await xmlPresignUrl(
      use_xml_id ? use_xml_id : xml?.id,
      prefix
    );
    if (!xml_url) {
      handleClickVariant(
        "Erreur lors de la récupération du fichier XML",
        "error"
      );
      setLoadingData(false);
      return;
    }

    let res: any = {
      url: "",
      attestationId: "",
    };

    res = await generatePDF(
      xml_url,
      [],
      "insulator",
      orgData.id,
      orgData,
      xml ? xml.id : "",
      orgData.infos.phone,
      orgData.infos.email,
      orgData.infos.address,
      orgData.infos.name,
      prefix
    );

    let attestation: Attestation = (await getDocDataById(
      "attestation",
      res.attestationId
    )) as Attestation;
    setNewAttestation(attestation);
    setLoadingData(false);
  };

  const extractCarbon = async (
    xml: Xml | undefined,
    insulator_carbon: boolean = false
  ) => {
    if (
      orgData.facturation.plan !== "active" &&
      orgData.counters?.attestations >= 5
    ) {
      handleClickVariant(
        "Vous avez atteint la limite de 5 attestations. Veuillez mettre à niveau votre plan pour en créer plus.",
        "error"
      );
      return;
    }

    console.log("extractCarbon", xml);
    setLoadingData(true);
    let xml_url = await xmlPresignUrl(
      use_xml_id ? use_xml_id : xml?.id,
      prefix
    );
    if (!xml_url) {
      handleClickVariant(
        "Erreur lors de la récupération du fichier XML",
        "error"
      );
      setLoadingData(false);
      return;
    }

    let { list, url, attestationId } = await extractXml(
      //url and attestationId are null
      xml_url,
      "carbon",
      xml ? xml.id : "",
      orgData.infos.phone,
      orgData.id,
      orgData.infos.email,
      orgData.infos.address,
      orgData.infos.name,
      prefix,
      orgData
    );
    setCarbonBatch(list);
    insulator_carbon
      ? setExtractStep("insulator_carbon")
      : setExtractStep("carbon");
    setLoadingData(false);
  };

  const generateComplexModelAttestation = async (
    xml: Xml | undefined,
    type: "insulator" | "carbon" | "insulator_carbon"
  ) => {
    let partner = partners.find((p: MaitreOeuvre) => p.id === xml?.partner_id);

    let ath_request = generateATHRequest(orgData, type, partner);

    let res = await generateATH2(
      xml?.file?.url || "",
      orgData,
      xml ? xml.id : "",
      ath_request,
      prefix
    );

    let attestation: Attestation = (await getDocDataById(
      "attestation",
      res.attestationId
    )) as Attestation;
    setNewAttestation(attestation);
    setLoadingData(false);
  };

  const generateCarbonAttestation = async (
    xml: Xml | undefined,
    selectedFields: any[] = []
  ) => {
    if (
      orgData.facturation.plan !== "active" &&
      orgData.counters?.attestations >= 5
    ) {
      handleClickVariant(
        "Vous avez atteint la limite de 5 attestations. Veuillez mettre à niveau votre plan pour en créer plus.",
        "error"
      );
      return;
    }
    setExtractStep(null);
    console.log("generateCarbonAttestation", xml);
    setLoadingData(true);

    let xml_url = await xmlPresignUrl(
      use_xml_id ? use_xml_id : xml?.id,
      prefix
    );
    if (!xml_url) {
      handleClickVariant(
        "Erreur lors de la récupération du fichier XML",
        "error"
      );
      setLoadingData(false);
      return;
    }

    let res = {
      url: "",
      attestationId: "",
    };

    res = await generatePDF(
      xml_url,
      selectedFields,
      "carbon",
      orgData.id,
      orgData,
      xml ? xml.id : "",
      orgData.infos.phone,
      orgData.infos.email,
      orgData.infos.address,
      orgData.infos.name,
      prefix
    );

    let attestation: Attestation = (await getDocDataById(
      "attestation",
      res.attestationId
    )) as Attestation;
    setNewAttestation(attestation);
    setLoadingData(false);
  };

  const generateInsulatorCarbonAttestation = async (
    xml: Xml | undefined,
    selectedFields: any[] = []
  ) => {
    if (
      orgData.facturation.plan !== "active" &&
      orgData.counters?.attestations >= 5
    ) {
      handleClickVariant(
        "Vous avez atteint la limite de 5 attestations. Veuillez mettre à niveau votre plan pour en créer plus.",
        "error"
      );
      return;
    }

    console.log("generateInsulatorCarbonAttestation", xml);
    setLoadingData(true);

    let xml_url = await xmlPresignUrl(
      use_xml_id ? use_xml_id : xml?.id,
      prefix
    );
    if (!xml_url) {
      handleClickVariant(
        "Erreur lors de la récupération du fichier XML",
        "error"
      );
      setLoadingData(false);
      return;
    }

    let res = {
      url: "",
      attestationId: "",
    };

    res = await generateBoth(
      xml_url,
      orgData.id,
      selectedFields,
      xml ? xml.id : "",
      orgData.infos.email,
      orgData.infos.address,
      orgData.infos.name,
      orgData.infos.phone,
      prefix,
      orgData
    );

    let attestation: Attestation = (await getDocDataById(
      "attestation",
      res.attestationId
    )) as Attestation;
    setNewAttestation(attestation);
    setLoadingData(false);
  };

  const handleCreateNewAttestation = async (xml: Xml | undefined) => {
    if (
      orgData.facturation.plan !== "active" &&
      orgData.counters?.attestations >= 5
    ) {
      handleClickVariant(
        "Vous avez atteint la limite de 5 attestations. Veuillez mettre à niveau votre plan pour en créer plus.",
        "error"
      );
      return;
    }

    console.log("handleCreateNewAttestation", xml);
    setLoadingData(true);
    // const updatedAttestation: Attestation = {
    //   id: generateID("attestation"),
    //   name: "Nouvelle attestation",
    //   num: "A-" + (orgData.counters?.attestations + 1 || 1).toString(),
    //   org_id: orgData.id,
    //   creation_date: getFlutterTime(),
    //   last_updated: getFlutterTime(),
    //   type: "insulator", // Default type, can be changed later
    //   xml_id: xml ? xml.id : "",
    //   tags: [],
    // };
    setNewOpen(true);

    setLoadingData(false);

    // try {
    //   await createDocApi("attestation", updatedAttestation, prefix);
    //   await updateDocDataFieldApi(
    //     orgData.ref!,
    //     "counters",
    //     {
    //       attestations: (orgData.counters?.attestations || 0) + 1,
    //     },
    //     prefix
    //   );

    //   handleClickVariant("Attestation créée avec succès", "success");
    //   setNewAttestation(updatedAttestation);
    //   setNewOpen(true);
    // } catch (error) {
    //   console.error("Error creating attestation:", error);
    //   handleClickVariant(
    //     "Erreur lors de la création de l'attestation",
    //     "error"
    //   );
    // } finally {
    //   setLoadingData(false);
    // }
  };

  useEffect(() => {
    if (orgData) {
      const { rows, columns } = transformFilesToTable(
        allattestations,
        activetab,
        orgData,
        searchValue,
        prefix
      );
      let sorted_rows = rows.sort((a: any, b: any) => {
        return a.name.trim().localeCompare(b.name.trim());
      });
      setRows(sorted_rows || []);
      setColumns(columns || []);
      setUpdateSearch(false);
    }
  }, [
    allattestations,
    orgData,
    userData,
    update_search,
    year,
    searchCarnets,
    searchValue,
    activetab,
  ]);

  const [loadingSelection, setLoadingSelection] = useState("");

  const handleSortChange = (sortModel: any) => {
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0]; // Get the field and sort direction
      let new_folders_config = folders_config || {};
      new_folders_config.field = field;
      new_folders_config.sort = sort;
      // set folders_config
      setAppState((prevState: any) => ({
        ...prevState,
        folders_config: new_folders_config,
      }));
      // You can add additional logic here, such as updating state or making an API call
    } else {
    }
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData();
    }
    if (orgData && !triggered) {
      setTriggered(true);
      handleCheckUseXmlId();
    }
  }, [orgData]);

  const [triggered, setTriggered] = useState(false);

  if (!userData || loadingRows) {
    return (
      <div className="h-full w-full pl-4 mr-4 flex flex-col items-center justify-center gap-2">
        <Spin />
      </div>
    );
  }

  // Render the client data
  return (
    <div className="flex flex-col h-full w-full pl-4 pb-6 pr-4 max-h-full max-w-c1p4k overflow-auto">
      {loadingFile !== "" && (
        <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-50 z-70 flex items-center justify-center">
          <SexySpin></SexySpin>
        </div>
      )}{" "}
      {modifyAttestation && (
        <ModalRight
          isOpen={modifyAttestation}
          onClose={() => {
            setModifyAttestation(false);
            setUpdatedAttestation(undefined);
          }}
        >
          <div
            className="flex flex-col gap-4 p-4 w-c500
      
          "
          >
            <div className="text-h2 text-black">Modifier une attestation</div>
            <div className="flex flex-col gap-2">
              <InfosBlockModify
                label="ID"
                value={updatedAttestation?.id || ""}
                onChange={(value: string) => {}}
                disabled={true}
              ></InfosBlockModify>
              <InfosBlockModify
                label="Nom"
                value={updatedAttestation?.name || ""}
                onChange={(value: string) => {
                  setUpdatedAttestation({
                    ...updatedAttestation!,
                    name: value,
                  });
                }}
              ></InfosBlockModify>

              {!updatedAttestation!.file ? (
                <div className="flex flex-col  justify-center items-center w-full hover:border-blue-400 border-1  bg-neutral-50 h-c50 rounded-lg overflow-hidden">
                  <Icon1 icon_name="file" size={20} fill="grey"></Icon1>
                </div>
              ) : (
                <div className="flex flex-row p-2 gap-3 items-center text-h3 w-full  border-1 bg-neutral-50 rounded-lg overflow-hidden">
                  <Icon1 icon_name="file" size={20} fill="grey"></Icon1>
                  <div className="flex flex-col mr-auto">
                    {updatedAttestation?.file ? (
                      <a
                        href={updatedAttestation.file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-blue-500  hover:underline"
                      >
                        {updatedAttestation?.file?.name}{" "}
                      </a>
                    ) : (
                      <span className="text-gray-500">Aucun file</span>
                    )}
                    <div className="text-gray-500 text-xs">
                      {updatedAttestation?.file?.octets
                        ? `(${(updatedAttestation.file.octets / 1024).toFixed(
                            2
                          )} Ko)`
                        : ""}
                    </div>
                  </div>
                  <div
                    className="cursor-pointer hover:text-red-500"
                    onClick={() => {
                      setUpdatedAttestation({
                        ...updatedAttestation!,
                        file: undefined,
                      });
                    }}
                  >
                    <Icon1 icon_name="delete" size={20} fill="grey"></Icon1>
                  </div>{" "}
                </div>
              )}
            </div>
            <div className="flex flex-row gap-2 justify-end w-full">
              <PrimaryButton
                onClick={() => {
                  handleSaveAttestation();
                }}
              >
                Enregistrer
              </PrimaryButton>
              <SecondaryButton
                onClick={() => {
                  handleDownload();
                }}
              >
                Télécharger
              </SecondaryButton>
              <SecondaryButton
                onClick={() => {
                  handleDownloadWord();
                }}
              >
                Word (.docx)
              </SecondaryButton>
              <SecondaryButton
                onClick={() => {
                  handleDeleteAttestation();
                }}
              >
                Supprimer
              </SecondaryButton>
            </div>
          </div>
        </ModalRight>
      )}
      {new_open && (
        <NewAttestationModal
          userData={userData}
          orgData={orgData}
          setOpen={setNewOpen}
          handleClickVariant={handleClickVariant}
          navigateWorkspace={navigateWorkspace}
          refreshData={handleFetchData}
          extractCarbon={extractCarbon}
          generateRTBAttestation={generateRTBAttestation}
          generateCarbonAttestation={generateCarbonAttestation}
          generateComplexModelAttestation={generateComplexModelAttestation}
          generateInsulatorAttestation={generateInsulatorAttestation}
          generateInsulatorCarbonAttestation={
            generateInsulatorCarbonAttestation
          }
          extractStep={extractStep}
          setExtractStep={setExtractStep}
          rtb_compatible={usedXml?.rtb_compatible || false} // Use the XML's rtb_compatible or default to true
          carbonBatch={carbonBatch}
          xmlId={use_xml_id ? use_xml_id : ""}
          newAttestation={newAttestation}
        ></NewAttestationModal>
      )}
      <div className="flex flex-col w-full  gap-4 h-fit  ">
        <div className="flex flex-row gap-1 justify-between ">
          <div className="text-hx font-medium">Mes attestations</div>
        </div>

        <div className="flex  gap-2 flex-row  2xl:justify-between h-fit">
          <BasicSearchBar
            onAction={() => {}}
            options={options}
            value={searchValue}
            setValue={handleSetSeachValue}
            placeholder="Rechercher une attestation..."
          ></BasicSearchBar>
        </div>
        {searchValue === "" && (
          <div className="flex flex-row gap-2 h-fit">
            <div className="ml-0 pl-0 left-0 relative">
              <TabGPT
                tabs={tabs}
                activeTab={activetab}
                setActiveTab={handleTabChange}
              />
            </div>
          </div>
        )}
      </div>
      {selected_ids.length > 0 && (
        <div className="my-4">
          <PrimaryButton onClick={handleDeleteSelectedAttestations}>
            Supprimer les attestations sélectionnées
            {loadingDelete && <SmallSpinner loading={true} />}
          </PrimaryButton>
        </div>
      )}
      <div className="w-full h-full max-h-[60%]  max-w-full mt-2">
        <DataGridGPT2
          is_folders={true}
          selectable={true}
          rows={rows}
          columns={columns}
          searchValue={searchValue || ""}
          onClick={gotoFolder}
          initial_asc={"desc"}
          initial_sort_field="creation_date"
          handleSortChange={handleSortChange}
          selected_ids={selected_ids}
          setSelectedIds={setSeletedIds}
          initial_saved_columns_showed={{
            id: false,
            rdv: false,
          }}
          initialPage={0}
          initialPageSize={100}
          orgData={orgData}
        ></DataGridGPT2>
      </div>
    </div>
  );
}

export default Folders;

export const generateATHRequest = (
  orgData: Org,
  type: string,
  partner?: MaitreOeuvre
) => {
  return {
    maitre_oeuvre: {
      nom: partner?.name || "use_operation_data",
      adresse: partner?.address || "use_operation_data",
      code_postal: partner?.postal || "use_operation_data",
      ville: partner?.city || "use_operation_data",
    },
    signataire: {
      nom: ".................................................",
      entreprise: partner?.name || "use_operation_data",
      qualite: "Maître d'Œuvre",
    },
    infiltrometre: {
      nom: orgData.infos.name,
      adresse: orgData.infos.address,
      code_postal: orgData.infos.postal,
      ville: orgData.infos.city,
    },
    reference: {
      nom: "M ET MME VANDECANDELAERE",
      adresse: "CHEMIN DE LA PLAINE",
      code_postal: "27390",
      ville: "SACQUEVILLE",
      creation_date: getLocalFromFlutterString(getFlutterTime()),
    },

    type: type,
    logo: orgData.logo,
    footer:
      "Ce document est une attestation de conformité aux exigences de la réglementation thermique",
  };
};
